import { render, staticRenderFns } from "./ConsumptionVoucher.vue?vue&type=template&id=2c6751ce&scoped=true"
import script from "./ConsumptionVoucher.vue?vue&type=script&lang=js"
export * from "./ConsumptionVoucher.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionVoucher.vue?vue&type=style&index=0&id=2c6751ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6751ce",
  null
  
)

export default component.exports